const sectionCustomizations = {
    title: "Your Wishlist",
    coverImage: "//barthelemy.com.br/cdn/shop/files/st_Barth.webp?v=1703608256",
    coverOpacity: "opacity_black",
    textAlign: "text-center",
    textColor: "text-white",
    textSize: "text-h6 md:text-h5",
    buttonStyle: "btn btn-primary",
    buttonWidth: "w-auto",
    headerHeightDesktop: 16,
    headerHeightMobile: 9.5, 
};
  
function insertHeaderSection() {
    if (window.location.pathname.includes('apps/wishlist')) {
      const headerSection = `
        <div class="relative flex flex-col justify-center header-short">
          <img
            srcset="${sectionCustomizations.coverImage}&width=1600 1600w, ${sectionCustomizations.coverImage}&width=1200 1200w, ${sectionCustomizations.coverImage}&width=832 832w, ${sectionCustomizations.coverImage}&width=352 352w"
            width="2"
            height="2"
            alt="Background Image"
            loading="lazy"
            fetchpriority="auto"
            class="image absolute inset-0 -z-20 w-full object-cover h-full"
          >
          <div
            class="absolute inset-0 -z-20 w-full object-cover ${sectionCustomizations.coverOpacity}"
          ></div>
          <div class="wrapper flex w-full flex-col ${sectionCustomizations.textAlign} container_text">
            <h2 class="title max-w-2xl font-serif font-bold w-full ${sectionCustomizations.textColor} ${sectionCustomizations.textSize}">
              ${sectionCustomizations.title}
            </h2>
          </div>
        </div>
      `;
  
      const mainElement = document.querySelector('main');
      if (mainElement) {
        mainElement.insertAdjacentHTML('afterbegin', headerSection);
      }
  
      const styles = `
        <style>
          .header-short {
            height: ${sectionCustomizations.headerHeightDesktop}rem;
          }
          .container_text {
            align-items: center;
          }
          .opacity_black { background-color: #0005; }
          .header-short > .relative,
          .header-short > .relative img,
          .header-short > .relative > div:nth-of-type(1) {
            height: ${sectionCustomizations.headerHeightDesktop}rem;
          }
          h1.title.max-w-2xl.font-serif.font-bold {
            padding-top: 1rem;
          }
          @media screen and (max-width: 768px) {
            .header-short {
              height: ${sectionCustomizations.headerHeightMobile}rem;
            }
            .header-short > .relative,
            .header-short > .relative img,
            .header-short > .relative > div:nth-of-type(1) {
              height: ${sectionCustomizations.headerHeightMobile}rem;
            }
            h1.title.max-w-2xl.font-serif.font-bold {
              padding-top: 2rem;
            }
          }
        </style>
      `;
  
      document.head.insertAdjacentHTML('beforeend', styles);
      
      const navHeader = document.getElementById('floating-menu-nav-element')
      navHeader.classList.remove('from-white/60');
      navHeader.classList.add('from-black/60');
    }
}

document.addEventListener('DOMContentLoaded', insertHeaderSection);